module.exports = __webpack_public_path__ + "img/sz.fa1a994.svg";